import { Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { CodeType } from '../../models/accounts.model';

// Rxjs
import { _throw } from 'rxjs/observable/throw';
import { Observable } from 'rxjs/Observable';

// Services
import { HttpService } from '../../../core/services/http.service';

// Base URL
import { BASE_URL } from '../../../core/services/api';

// Interfaces
import { Account } from '../interfaces/account.interface';
import { Phone, Phone2FA } from '../interfaces/phone.interface';
import { LANGUAGES } from '../../../translation/translation';

@Injectable()
export class AccountStaffService {

  // Base URL
  private PATH: string = BASE_URL + 'staff/';

  // Constructor
  constructor(private http: HttpService) { }

  // Check Email
  public emailVerification(email: { email: string }): Observable<Response> {
    return this.http.get(this.PATH + 'staff/email-verification?email=' + email.email);
  }

  // Update Client Account
  public updateClientAccount(account: Account): Observable<Response> {
    return this.http.put(this.PATH + 'staff/update-staff-account', account);
  }

  // Update Client Phone Number
  public updateClientPhone(phone: Phone): Observable<Response> {
    const data = {
      phone: phone.cli_phone,
      countryCode: phone.country_code,
      dialCode: phone.dial_code
    };
    return this.http.put(this.PATH + 'staff/change-phone', data);
  }

  // Update Client Phone Number 2FA
  public updateClientPhone2FA(phone: Phone2FA): Observable<Response> {
    return this.http.put(this.PATH + 'staff/change-phone-with-factor', phone);
  }

  // 2FA Phone Verification Call
  public tfaPhoneCall(phone: Phone): Observable<Response> {
    const data = {
      phone: phone.cli_phone,
      countryCode: phone.country_code,
      dialCode: phone.dial_code
    };
    return this.http.post(this.PATH + 'staff/call-to-phone', data);
  }

  // Update Client 2FA Configuration
  public update2FAConfiguration(status): Observable<Response> {
    return this.http.put(this.PATH + 'staff/staff-account-security', status);
  }

  // Verify Client 2FA Configuration
  public verify2FAConfiguration(tfaCode: string, tfaType: CodeType): Observable<Response> {
    console.log('account.service.ts:verify2FAConfiguration  tfaCode=', tfaCode, '  tfaType=', tfaType);
    return this.http.post(this.PATH + 'staff/tfa-verification', { tfaCode, tfaType });
  }

  // Change Client Password
  public changeClientPassword(values): Observable<Response> {
    return this.http.put(this.PATH + 'staff/staff-change-password', values);
  }

  // Send Validation Code To Email Address
  public sendCodeToEmailAddress(email): Observable<Response> {
    return this.http.post(this.PATH + 'staff/send-email-code', email);
  }

  // Validate Email Address
  public validateEmailAddress(email: string, emailCode: string): Observable<Response> {
    return this.http.post(this.PATH + 'staff/change-email-with-code', { email, emailCode });
  }

  // Get Role Permissions
  public getRolePermissions(): Observable<Response> {
    return this.http.get(BASE_URL + 'staff/role/role-permissions-current-user');
  }

  // Get Client Projects
  /*public getClientProjects(): Observable<Response> {
    return this.http.get(BASE_URL + 'project/project/get-projects-list');
  }*/

}



// WEBPACK FOOTER //
// ./src/app/staff/my-account/services/account.service.ts